import { mobile } from '@Shared/Device'
import Vue from 'vue'
import { inicializarVueNoElemento } from './VueHooks'

const MODAL_LATERAL_ANIM_TIMEOUT = 350
const MODAL_LATERAL_CLOSE_ANIM_TIMEOUT = 200
const MODAL_CENTRAL_ANIM_TIMEOUT = 100
const MODAL_CENTRAL_CLOSE_ANIM_TIMEOUT = 100

const modalTypeConfig = {
    lateral: {
        openTimeout: MODAL_LATERAL_ANIM_TIMEOUT,
        openClass: 'modal-lateral-open',
        loadingHtml: () => {
            escorregarModaisAbertosParaEsquerda()
            let largura = mobile() ? '100%' : 'var(--modal-lateral-largura)'

            return `
            <div id="modal" data-layout="lateral" class="absolute top-0 right-0 h-screen bg-white text-gray-700 shadow-lg dark:bg-dark-600 dark:text-gray-200" style="width: ${largura};">
                <div class="w-full h-full flex items-center justify-center text-gray-600 text-lg dark:text-gray-400">
                    ${__('Carregando...')}
                </div>
            </div
            `
        },
        close: (modal, callback) => {
            escorregarModaisAbertosParaDireita()
            modal.classList.add('modal-lateral-close')
            setTimeout(callback, MODAL_LATERAL_CLOSE_ANIM_TIMEOUT)
        },
    },
    central: {
        openTimeout: MODAL_CENTRAL_ANIM_TIMEOUT,
        openClass: 'modal-central-open',
        loadingHtml: () => {
            return `
            <div id="modal" data-layout="central" class="overflow-auto rounded-lg bg-white dark:bg-dark-600" style="max-width: 700px; max-height: calc(100% - calc(20px * 2)); margin: 20px 0;">
                <div class="w-full h-full flex items-center justify-center text-gray-600 text-lg p-6 font-bold dark:text-gray-200">
                    ${__('Carregando...')}
                </div>
            </div
            `
        },
        close: (modal, callback) => {
            modal.classList.add('modal-central-close')
            setTimeout(callback, MODAL_CENTRAL_CLOSE_ANIM_TIMEOUT)
        },
    },
    page: {
        openTimeout: 0,
        openClass: null,
        loadingHtml: backdrop => {
            backdrop.style.setProperty('pointer-events', 'none')
            backdrop.style.setProperty('background', 'none')
            backdrop.style.setProperty('backdrop-filter', 'none')

            return `
            <div id="modal" data-layout="page" class="fixed m-4 rounded-md pointer-events-auto top-0 bottom-0 left-0 md:left-[var(--modal-page-left)] right-0 overflow-auto z-40  bg-white  text-gray-700 dark:bg-dark-600 dark:text-gray-200 dark:border-dark-900">
                <div class="w-full h-full flex items-center justify-center text-gray-600 text-lg p-6 font-bold dark:text-gray-200">
                    ${__('Carregando...')}
                </div>
            </div>
            `
        },
        close: (modal, callback) => {
            callback()
        },
    },
    fullscreen: {
        openTimeout: 0,
        openClass: null,
        loadingHtml: backdrop => {
            backdrop.style.setProperty('pointer-events', 'none')
            backdrop.style.setProperty('background', 'none')
            backdrop.style.setProperty('backdrop-filter', 'none')

            return `
            <div id="modal" data-layout="fullscreen" class="fixed pointer-events-auto top-0 bottom-0 left-0 md:left-[var(--modal-fullscreen-left)] right-0  bg-white  overflow-auto z-40 border-l border-gray-200 dark:bg-dark-700 dark:text-gray-200 dark:border-dark-900">
                <div class="w-full h-full flex items-center justify-center text-gray-600 text-lg p-6 font-bold dark:text-gray-200">
                    ${__('Carregando...')}
                </div>
            </div>
            `
        },
        close: (modal, callback) => {
            callback()
        },
    },
}

export function abrirModalUrl(url, opts = {}) {
    let modal = abrirModal(url, opts)
    carregarUrlNoModal(url, modal)
}

export function abrirModalHtml(html, opts = {}) {
    let modal = abrirModal(html, opts)

    modal.innerHTML = html
    inicializarVueNoElemento(modal)
}

/**
 * Funções disponíveis globalmente.
 */
window.abrirModalUrl = abrirModalUrl
window.abrirModalHtml = abrirModalHtml
Vue.prototype.abrirModalUrl = abrirModalUrl
Vue.prototype.abrirModalHtml = abrirModalHtml

/**
 * Abre o modal de acordo com o layout
 *
 * @param {string} id
 * @param {object} opts
 */
function abrirModal(id, opts = {}) {
    esconderScrollDoBody()

    let backdrop = document.createElement('div')
    backdrop.setAttribute('data-modal-backdrop', 'true')
    backdrop.setAttribute('data-url', id)
    backdrop.className = 'fixed top-0 left-0 w-full h-full flex justify-center items-start overflow-hidden z-20'
    backdrop.style.background = 'rgba(50, 50, 50, 0.5)'
    backdrop.style.setProperty('backdrop-filter', 'blur(4px)')

    let modalConfig = modalTypeConfig[opts.layout || 'lateral']
    let openTimeout = modalConfig.openTimeout
    let openClass = modalConfig.openClass
    backdrop.innerHTML = modalConfig.loadingHtml(backdrop)

    let modal = backdrop.querySelector('#modal')
    modal.classList.add(openClass)

    backdrop.fechar = function(opts = {}) {
        return new Promise((resolve, reject) => {
            backdrop.setAttribute('data-closing', 'true')
            let modal = backdrop.querySelector('#modal')

            if (modal.querySelector('form[has-unsaved-changes]') && !opts.force) {
                let msg = __('Parece que você possui alterações não salvas. Tem certeza que deseja fechar?')
                if (!window.confirm(msg)) {
                    return reject()
                }
            }

            let modalConfig = modalTypeConfig[modal.getAttribute('data-layout') || 'lateral']
            modalConfig.close(modal, () => {
                if (document.body.contains(backdrop)) {
                    document.body.removeChild(backdrop)
                }
                resolve()
                document.dispatchEvent(new CustomEvent('reflinks:modal-close'))
            })

            if (!document.body.querySelector('#modal')) {
                restaurarScrollDoBody()
            }
        })
    }

    backdrop.addEventListener('mouseup', ev => {
        if (document.__latestMouseDownTarget == backdrop && ev.target == backdrop) {
            backdrop.fechar()
        }
    })

    document.body.appendChild(backdrop)
    setTimeout(() => {
        modal.classList.remove(openClass)
    }, openTimeout)

    return modal
}

document.addEventListener('mousedown', ev => {
    document.__latestMouseDownTarget = ev.target
})

export function recarregarÚltimoModal() {
    let modais = document.querySelectorAll('[data-modal-backdrop]:not([data-closing])')
    let últimoModal = modais[modais.length - 1]

    if (últimoModal) {
        let url = últimoModal.getAttribute('data-url')
        if (url) {
            carregarUrlNoModal(url, últimoModal.querySelector('#modal'))
        } else {
            console.log('[err] Tentando recarregar último modal mas não existe URL nos atributos')
        }
    }
}

export function fecharModais(opts) {
    let backdrops = Array.from(document.querySelectorAll('[data-modal-backdrop]'))

    backdrops.forEach(backdrop => {
        backdrop.fechar(opts)
    })
}

export async function fecharModaisDeEdição(opts) {
    let backdrops = Array.from(document.querySelectorAll('[data-modal-backdrop]'))

    for (let backdrop of backdrops) {
        if (backdrop.getAttribute('data-url')?.indexOf('/edit') !== -1) {
            await backdrop.fechar(opts)
        }
    }
}

export async function fecharModaisDeCriação(opts) {
    let backdrops = Array.from(document.querySelectorAll('[data-modal-backdrop]'))

    for (let backdrop of backdrops) {
        if (backdrop.getAttribute('data-url')?.indexOf('/create') !== -1) {
            await backdrop.fechar(opts)
        }
    }
}

export async function fecharÚltimoModal(opts) {
    let modais = Array.from(document.querySelectorAll('[data-modal-backdrop]'))
    let últimoModal = modais[modais.length - 1]

    if (últimoModal) {
        return await últimoModal.fechar(opts)
    }
}

function carregarUrlNoModal(url, modal) {
    axios({
        method: 'GET',
        url,
        headers: {
            'X-Reflinks': '1',
            Accept: 'text/html',
        },
    })
        .then(res => {
            let doc = document.createElement('html')
            doc.innerHTML = res.data
            let content = doc.querySelector('[data-reflinks-content]')

            console.log(content)

            modal.innerHTML = ''
            modal.appendChild(content)
            inicializarVueNoElemento(content)
        })
        .catch(res => {
            // TODO: Mostrar algum aviso de falha no modal
        })
}

function escorregarModaisAbertosParaEsquerda() {
    let modaisAbertos = Array.from(document.body.querySelectorAll('#modal'))

    modaisAbertos.forEach((modal, índice) => {
        let distância = (índice + 1) * 60
        modal.style.transform = `translateX(-${distância}px)`
    })
}

function escorregarModaisAbertosParaDireita() {
    let modaisAbertos = Array.from(document.body.querySelectorAll('#modal'))

    modaisAbertos.forEach((modal, índice) => {
        let distância = índice * 60
        modal.style.transform = `translateX(-${distância}px)`
    })
}

function esconderScrollDoBody() {
    document.body.style.overflow = 'hidden'
}

function restaurarScrollDoBody() {
    document.body.style.overflow = 'auto'
}
